var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-page-content",
    attrs: {
      "id": "app-page-content"
    }
  }, [_vm._l(_vm.appList, function (item) {
    return _c('div', {
      key: item.code,
      staticClass: "apps-list"
    }, [_c('div', {
      staticClass: "title"
    }, [!item.icon ? _c('Icon', {
      staticClass: "icon-app",
      attrs: {
        "type": "ios-aperture"
      }
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(item.name))])], 1), _c('draggable', {
      staticClass: "card-flex",
      attrs: {
        "delay": "100",
        "handle": _vm.card
      },
      on: {
        "change": function ($event) {
          return _vm.change($event, item.apps);
        }
      },
      model: {
        value: item.apps,
        callback: function ($$v) {
          _vm.$set(item, "apps", $$v);
        },
        expression: "item.apps"
      }
    }, [_vm._l(item.apps, function (card) {
      return _c('div', {
        key: card.id,
        staticClass: "card",
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.jump(card);
          }
        }
      }, [_c('Card', [_c('div', {
        staticClass: "card-list"
      }, [_c('img', {
        staticClass: "card-img",
        attrs: {
          "src": card.icon || _vm.defaultImg
        }
      }), _c('h3', [_vm._v(" " + _vm._s(card.name) + " ")])])])], 1);
    }), _vm._l(_vm.felxList, function (v, index) {
      return _c('i', {
        key: index + 's',
        staticClass: "card-felx-i"
      });
    })], 2)], 1);
  }), _vm.showMore ? _c('More', {
    on: {
      "jump": _vm.jump
    }
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };